import { DateTime } from 'luxon'

function convertDateStringsToDates(input) {
  // Ignore things that aren't objects.
  if (typeof input !== "object") {
    return input
  }
  for (var key in input) {
    if (!Object.prototype.hasOwnProperty.call(input, key)) {
      continue
    }

    var value = input[key]
    // Check for string properties which look like dates.
    if (typeof value === "string" && (key.endsWith('Date') || key.endsWith('Time'))) {
      // let dateValue = new Date(value)
      // if (value.match(localDateRegex)) {
      //   //dateValue = DateTime.fromISO(value).toJSDate()
      // } else if (value.match(localDateTimeRegex)) {
      //   dateValue = new Date(value)
      // }
      const date = DateTime.fromISO(value).toJSDate()
      input[key] = date

    } else if (typeof value === "object") {
      // Recurse into object
      convertDateStringsToDates(value)
    }
  }
}

httpResponseInterceptor.$inject = []
function httpResponseInterceptor() {
  return {
    response: function (resp) {
      if (resp && resp.headers('content-type') === 'application/json; charset=utf-8') {
        convertDateStringsToDates(resp.data)
      }
      return resp
    }
  }
}
export default httpResponseInterceptor